export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.26.2',
};
//# sourceMappingURL=buildEnv.js.map